import { Component, OnInit } from '@angular/core';
import { PayService } from '../service/pay.service';

type UploadType = 'profile' | 'recto' | 'verso';

@Component({
  selector: 'app-identification',
  templateUrl: './identification.component.html',
  styleUrls: ['./identification.component.css'],
  standalone: false
})
export class IdentificationComponent implements OnInit {
  isSave = false;
  loader = false;

  urlProfile = '';
  urlRecto = '';
  urlVerso = '';
  urlVersoMineur = '';
  urlRectoMineur = '';

  selectedProfileFile: File | null = null;
  selectedRectoFile: File | null = null;
  selectedVersoFile: File | null = null;

  selectedProfileName = '';
  selectedRectoName = '';
  selectedVersoName = '';

  uploadMessage = '';
  uploadError = '';

  constructor(private userService: PayService) {
  }

  ngOnInit(): void {
    this.afficher();
  }

  onDocumentSelected(event: Event, type: UploadType): void {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files.length > 0 ? input.files[0] : null;

    if (!file) {
      return;
    }

    this.uploadError = '';
    this.uploadMessage = '';

    if (type === 'profile') {
      this.selectedProfileFile = file;
      this.selectedProfileName = file.name;
      return;
    }

    if (type === 'recto') {
      this.selectedRectoFile = file;
      this.selectedRectoName = file.name;
      return;
    }

    this.selectedVersoFile = file;
    this.selectedVersoName = file.name;
  }

  uploadProfile(): void {
    this.uploadSelectedFile(this.selectedProfileFile, 5, 'Photo de profil envoyée avec succès.');
  }

  uploadRecto(): void {
    this.uploadSelectedFile(this.selectedRectoFile, 2, 'Recto CNI envoyé avec succès.');
  }

  uploadVerso(): void {
    this.uploadSelectedFile(this.selectedVersoFile, 1, 'Verso CNI envoyé avec succès.');
  }

  private uploadSelectedFile(file: File | null, action: number, successMessage: string): void {
    if (!file) {
      this.uploadError = 'Veuillez sélectionner une image avant l\'envoi.';
      return;
    }

    const formData = new FormData();
    formData.append('file', file, file.name);

    this.loader = true;
    this.uploadError = '';
    this.uploadMessage = '';

    this.userService.uploadFile(formData, action).subscribe({
      next: () => {
        window.scroll(0, 0);
        this.loader = false;
        this.isSave = true;
        this.uploadMessage = successMessage;
        this.clearSelectedFile(action);
        this.afficher();
        setTimeout(() => {
          this.isSave = false;
          this.uploadMessage = '';
        }, 3000);
      },
      error: () => {
        this.loader = false;
        this.isSave = false;
        this.uploadError = 'Échec de l\'envoi. Vérifiez le format du fichier et réessayez.';
      }
    });
  }

  private clearSelectedFile(action: number): void {
    if (action === 5) {
      this.selectedProfileFile = null;
      this.selectedProfileName = '';
      return;
    }
    if (action === 2) {
      this.selectedRectoFile = null;
      this.selectedRectoName = '';
      return;
    }
    if (action === 1) {
      this.selectedVersoFile = null;
      this.selectedVersoName = '';
    }
  }

  afficher(): void {
    this.userService.getUserIdentity().subscribe({
      next: (data: any) => {
        const identity = data || {};
        this.urlProfile = identity['urlProfile'] || '';
        this.urlRecto = identity['urlRecto'] || '';
        this.urlVerso = identity['urlVerso'] || '';
        this.urlVersoMineur = identity['urlVersoMineur'] || '';
        this.urlRectoMineur = identity['urlRectoMineur'] || '';
      },
      error: () => {
        this.urlProfile = '';
        this.urlRecto = '';
        this.urlVerso = '';
        this.urlVersoMineur = '';
        this.urlRectoMineur = '';
      }
    });
  }
}
